export default __webpack_public_path__ + "static/media/bg-right-scale.726486d5.svg";